import { publicUrlFor } from "../../../../globals/constants";
import { NavLink } from "react-router-dom";
import { neuronMedia, services } from "../../../../globals/neuron-content";

function SectionWhyChooseUs1() {
  return (
    <>
      <div className="section-full p-t110 p-b80 sx-why-chooseus-outer sx-bg-light bg-cover" style={{ backgroundImage: `url(${publicUrlFor(neuronMedia.banners.main)})` }}>
        <div className="container">
          <div className="section-head center">
            <div className="sx-head-s-title">Why Choose Us</div>
            <div className="sx-head-l-title"><h2 className="sx-title">A disciplined security partner for high-responsibility operations</h2></div>
          </div>
          <div className="section-content">
            <div className="sx-icon-bx-wrap">
              <div className="row">
                {services.map((service) => (
                  <div key={service.slug} className="col-lg-4 col-md-6 wow fadeInDown" data-wow-duration="1000ms">
                    <div className="sx-icon-bx-1">
                      <div className="sx-icon-box-wraper">
                        <div className="sx-icon-bx-icon "><span className="sx-text-primary"><i className={service.icon || "flaticon-security"} /></span></div>
                        <div className="icon-content">
                          <NavLink to={`/services/${service.slug}`}><h4 className="sx-tilte">{service.title}</h4></NavLink>
                          <p>{service.summary}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default SectionWhyChooseUs1;
